const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. CSV-Datei-Upload',
      subTitle: 'Wählen Sie die entsprechende Datei',
      body: {
        title: 'CSV-Datei',
        btn: 'Hochladen',
        downloadExample: 'CSV-Beispiel herunterladen',
        templateLabel: 'Mapping-Vorlage auswählen (optional)',
        templateDescription: 'Vorlage geladen. Sie können die Konfiguration unten bei Bedarf ansehen oder bearbeiten.',
      },
    },
    mappingFields: {
      title: '2. Felder zuordnen',
      subTitle: 'Bestätigen Sie, dass jedes Attribut der richtigen Spalte zugeordnet ist',
      toast: 'Duplizierter Wert',
      selectInputPlaceHolder: 'Feld auswählen'
    },
    integrityCheck: {
      title: '3. Integritätsprüfung',
      subTitle: 'Überprüfen der Dateiwerte',
    },
    import: {
      title: '4. Import',
      subTitle: 'Importieren der Daten',
      doneText: 'Datei erfolgreich importiert',
      doneBtn: 'Erledigt',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'Felder in der Datenbank',
      csvFile: 'CSV-Datei',
      format: 'Format',
      defaultValue: 'Standardwert',
    },
    hideTableBtn: 'Tabelle ausblenden',
    showTableBtn: 'Tabelle anzeigen',
    saveAsTemplateBtn: 'Als Vorlage speichern',
    templateNameLabel: 'Vorlagenname',
    saveTemplateDescription: 'Speichern Sie Ihre aktuellen Feldzuordnungen als Vorlage zur zukünftigen Verwendung.',
    updateTemplateDescription: 'Sie können die vorhandene Vorlage {{templateName}} aktualisieren oder als neue Vorlage speichern.',
    saveTemplateBtn: 'Speichern',
    saveAsNewBtn: 'Als neu speichern',
    updateTemplateBtn: 'Vorlage aktualisieren',
    nextBtn: 'Nächste',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'Nur Probleme anzeigen',
    disableSubmit: 'Fehler überspringen',
    totalCount: 'Gesamt: {{count}}',
    exportErrorList: 'Fehlerliste exportieren',
    rowContainErroe: '{{count}} Zeile enthält Fehler.',
    importBtn: 'Importieren'
  },

  submit: {
    errors: '{{errors}} Zeilen konnten nicht gepusht werden',
  }
};

export default dataUpload;
